
// export const myGetter = ( state ) => {
//  return state
// }

export const currentStatus = ( state ) => {
 return state.status
}

export const fullName = ( state ) => {
    let fullname = ''

    if (state.user?.employee) {
        fullname = `${state.user?.employee.firstName} ${state.user?.employee.lastName}`
    }

    if (state.user?.staffer) {
        fullname = `${state.user?.staffer.firstName} ${state.user?.staffer.lastName}`
    }
    
    return fullname
}

export const username = ( state ) => {
    return state.user?.username || ''
}

export const subsidiaries = ( state ) => {
    return state.user?.employee.subsidiaries || []
}

export const employeeData = ( state ) => {
    return state.user?.employee || null
}

export const stafferData = ( state ) => {
    return state.user?.staffer || null
}

export const userData = ( state ) => {
    return state.user || null
}

export const userMenus = ( state ) => {
    const menus = []
    if (state.user?.rol) {
        const userMenus = state.user.rol.menu.split(',')
        for (let index = 0; index < userMenus.length; index++) {
            const userMenu = userMenus[index];
            menus.push(userMenu)
        }
    }

    return menus
}

export const userPermissions = ( state ) => {
    const permissions = []
    if (state.user?.rol) {
        if (state.user.rol.permissions) {
            const userPermissions = state.user.rol.permissions.split(',')
            for (let index = 0; index < userPermissions.length; index++) {
                const userPermission = userPermissions[index];
                permissions.push(userPermission)
            }
        }
    }

    return permissions
}
